<template>
  <div class="filters">
    <div class="filters-wrapper">
      <button
        :class="[order === 'asc' ? 'ordering-button-asc' : 'ordering-button-desc']"
        @click="toggleOrder">
        {{ order === 'asc' ? $t('filters.DATE_ASC') : $t('filters.DATE_DESC') }}
      </button>
      <div>
        <label>
          <input
            @change="toggleHide"
            :checked="this.hide"
            type="checkbox">
          {{ $t('filters.HIDE') }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Filters',
  props: {
    hide: Boolean,
    order: String
  },
  methods: {
    toggleOrder () {
      const order = this.order === 'asc' ? 'desc' : 'asc'
      this.$emit('sort', order)
      localStorage.setItem('order', JSON.stringify(order))
    },
    toggleHide () {
      const hide = !this.hide
      this.$emit('hide', hide)
      localStorage.setItem('hide', JSON.stringify(hide))
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/base.scss";
$bg-darker: adjust-color($bg, $lightness: -10%);

.filters {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  padding: 5px;
  background-color: $bg;
  border-bottom: #e3e3e3 1px solid;
}

.filters-wrapper {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 50%;
}

%ordering-button {
  @extend %button;
  padding: 0.5em;
  min-width: 11em;
  background-color: transparent;
  transition: none;

  &:hover {
    background-color: $bg-darker;
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }
}

@mixin ordering-button-icon($button-url) {

  &::after {
    margin-left: 5px;
    content: url($button-url);
    height: 20px;
    width: 20px;
    display: inline;
  }
}

.ordering-button-asc {
  @extend %ordering-button;
  @include ordering-button-icon("~@/assets/arrow-down.svg")
}

.ordering-button-desc {
  @extend %ordering-button;
  @include ordering-button-icon("~@/assets/arrow-up.svg")
}

label {
  padding: 0.62em;
  min-width: 11em;
  border-radius: 3px;
  line-height: 24px;
  font-size: 16px;

  &:hover {
    background-color: $bg-darker;
    cursor: pointer;
  }
}

input[type=checkbox] {
  -webkit-appearance: none;
  appearance: none;
  width: 1rem;
  height: 1rem;
  border: 1px $checkbox-color solid;
  border-radius: 2px;
  cursor: pointer;
  margin-right: 5px;
  position: relative;

  &:hover {
    background: $checkbox-color;
  }

  &::before {
    content: url("~@/assets/check.svg");
    position: relative;
    top: 0;
    left: 1px;
    visibility: hidden;
  }

  &:checked {
    border: transparent 1px solid;
    background: $main-medium;
  }

  &:checked::before {
    visibility: visible;
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }
}

</style>
